import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import it from './locales/it.json';
import de from './locales/de.json';

// Spanish is the source language: keys ARE the Spanish texts.
// Missing translations fall back to the key itself (Spanish).
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      pt: { translation: pt },
      it: { translation: it },
      de: { translation: de },
    },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en', 'fr', 'pt', 'it', 'de'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    keySeparator: false,
    nsSeparator: false,
    returnEmptyString: false,
    parseMissingKeyHandler: (key) => key,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'app_language',
    },
  });

export default i18n;
